import { Component, Input, OnInit } from '@angular/core';
import { Product } from 'app/wipperoz-core/types/pricing/product.model';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-plan-item',
  templateUrl: './plan-item.component.html',
  styleUrls: ['./plan-item.component.scss']
})
export class PlanItemComponent implements OnInit {
  @Input() product: Product;
  @Input() index: number;

  productNote = '';
  productKeyData = '';
  productKeyData1 = '';
  productKeyData2 = '';
  productKeyData3 = '';
  productKeyData4 = '';
  productDescription = '';
  interval = '';
  urlSignUp = `${environment.appUrl}/auth/signup`;

  constructor() {}

  ngOnInit(): void {
    this.product.prices = this.product.prices.sort((a, b) => {
      return a.unit_amount - b.unit_amount;
    });

    switch (this.product.prices[0].recurring.interval) {
      case 'month': {
        this.interval = $localize`:@@productIntervalMonth:month`;
        break;
      }
      case 'day': {
        this.interval = $localize`:@@productIntervalDay:day`;
        break;
      }
      case 'year': {
        this.interval = $localize`:@@productIntervalYear:year`;
        break;
      }
    }

    switch (this.product.description) {
      case 'The free starter plan for everyone!': {
        this.productDescription = $localize`:@@starterProductDescription:The free starter plan for everyone!`;
        break;
      }
      case 'Unlimited flat rate plan': {
        this.productDescription = $localize`:@@ultimateProductDescription:Unlimited flat rate plan`;
        break;
      }
    }

    switch (this.product.metadata.productKeyData) {
      case 'Always free': {
        this.productKeyData = $localize`:@@starterProductKeyData:Always free`;
        break;
      }
      case "Send as many quotes as you'd like": {
        this.productKeyData = $localize`:@@ultimateProductKeyData:Send as many quotes as you'd like`;
        break;
      }
    }
    switch (this.product.metadata.productKeyData1) {
      case "Don't wait for quotes, find your supplier": {
        this.productKeyData1 = $localize`:@@starterProductKeyData1:Don't wait for quotes, find your supplier`;
        break;
      }
      case 'Be part of the suppliers directory*': {
        this.productKeyData1 = $localize`:@@ultimateProductKeyData1:Be part of the suppliers directory*`;
        break;
      }
    }
    switch (this.product.metadata.productKeyData2) {
      case 'Zero fees and no commissions': {
        this.productKeyData2 = $localize`:@@starterProductKeyData2:Zero fees and no commissions`;
        break;
      }
      case '20% discount on yearly subscription': {
        this.productKeyData2 = $localize`:@@ultimateProductKeyData2:20% discount on yearly subscription`;
        break;
      }
    }
    switch (this.product.metadata.productKeyData3) {
      case 'Receive unlimited quotes': {
        this.productKeyData3 = $localize`:@@starterProductKeyData3:Receive unlimited quotes`;
        break;
      }
      case 'Pre pay subscription': {
        this.productKeyData3 = $localize`:@@ultimateProductKeyData3:Pre pay subscription`;
        break;
      }
    }
    switch (this.product.metadata.productKeyData4) {
      case 'Send up to 5 free quotes': {
        this.productKeyData4 = $localize`:@@starterProductKeyData4:Send up to 5 free quotes`;
        break;
      }
      default: {
        this.productKeyData4 = ''; //$localize`:@@starterProductKeyData4:Send up to 5 free quotes`;
      }
    }
    switch (this.product.metadata.productNote) {
      case '*Suppliers must keep a ranking above 4.5 and pay the subscription on time': {
        this.productNote = $localize`:@@ultimateproductNote:*Suppliers must keep a ranking above 4.5 and pay the subscription on time`;
        break;
      }
      default: {
        this.productNote = ''; //$localize`:@@ultimateproductNote:*Suppliers must keep a ranking above 4.5 and pay the subscription on time`;
      }
    }
  }
}
